import styled from "styled-components";

const SideBarLink = styled.a`
  color: #000000; 
  font-size: 1em;
  margin-bottom: 25px;
  font-weight: ${props => props.current ? `bold` : `normal`};
  text-decoration: none;
  cursor: pointer;
  
  &:hover {
    color: #669933; 
    text-decoration: underline;
  }
`;

export default SideBarLink;
